'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
var alert$1 = require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
var fontIcon$1 = require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
var alert = require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
var fonts = require('../../../../themes/fonts.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
require('@brandfolder/utilities');
var closeButton = require('../../button/close-button/close-button.js');
require('../../button/color-button/color-button.js');
require('../../../../utilities/color.js');
require('date-fns');
require('../../../../utilities/locale.js');
require('../../../../hooks/use-prevent-keyboard-scrolling.js');
require('../../tooltip/hover-tooltip/hover-tooltip.js');
var fontIcon = require('../../icon/font-icon/font-icon.js');
require('react-laag');
require('react-transition-group');
require('../../button/icon-button/icon-button.js');
require('../../button/standard-button/standard-button.js');
require('../../loader/circle-loader/circle-loader.js');
require('../../loader/shimmer-loader/shimmer-loader.js');
var baseAlert = require('../base-alert/base-alert.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseStandardAlert = (props)=>{
    const { bodyWrapperProps , children , className , closeButtonProps , heading , headingWrapperProps , icon , iconProps , iconWrapperProps , labels ={} , look , messageWrapperProps , onClose , showClose =false , showHeading =true , showIcon =true , ...otherProps } = props;
    const { closeButtonLabel  } = labels;
    const [closed, setClosed] = React.useState(false);
    const getIcon = ()=>{
        if (icon) return icon;
        switch(look){
            case alert$1.AlertLooks.Error:
                {
                    return fontIcon$1.FontIcons.Alert;
                }
            case alert$1.AlertLooks.Success:
                {
                    return fontIcon$1.FontIcons.CheckMarkCircle;
                }
            case alert$1.AlertLooks.Warning:
                {
                    return fontIcon$1.FontIcons.Warning;
                }
            default:
                {
                    // AlertLooks.None
                    return null;
                }
        }
    };
    const fontIcon$2 = getIcon();
    const handleClose = ()=>{
        setClosed(true);
        if (onClose) onClose();
    };
    if (closed) return null;
    return /*#__PURE__*/ React__default.default.createElement(baseAlert.BaseAlert, _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-alert__standard': true,
            [`bf-alert__standard--${look}`]: look !== alert$1.AlertLooks.None,
            'bf-alert__standard--has-close-button': showClose,
            'bf-alert__standard--has-heading': showHeading,
            'bf-alert__standard--has-icon': showIcon,
            [`${className}`]: !!className
        })
    }), showIcon && fontIcon$2 && /*#__PURE__*/ React__default.default.createElement("div", _extends({}, iconWrapperProps, {
        className: classnames__default.default({
            'bf-alert__icon': true,
            [`${iconWrapperProps?.className}`]: !!iconWrapperProps?.className
        })
    }), /*#__PURE__*/ React__default.default.createElement(fontIcon.FontIcon, _extends({}, iconProps, {
        icon: fontIcon$2,
        iconSize: iconProps?.iconSize || 18
    }))), /*#__PURE__*/ React__default.default.createElement("div", _extends({}, bodyWrapperProps, {
        className: classnames__default.default({
            'bf-alert__body': true,
            [`${bodyWrapperProps?.className}`]: !!bodyWrapperProps?.className
        })
    }), heading && showHeading && /*#__PURE__*/ React__default.default.createElement("div", _extends({}, headingWrapperProps, {
        className: classnames__default.default({
            'bf-alert__heading': true,
            [`${headingWrapperProps?.className}`]: !!headingWrapperProps?.className
        })
    }), heading), /*#__PURE__*/ React__default.default.createElement("div", _extends({}, messageWrapperProps, {
        className: classnames__default.default({
            'bf-alert__message': true,
            [`${messageWrapperProps?.className}`]: !!messageWrapperProps?.className
        })
    }), children)), showClose && closeButtonLabel && /*#__PURE__*/ React__default.default.createElement(closeButton.CloseButton, _extends({}, closeButtonProps, {
        "aria-label": closeButtonLabel,
        icon: fontIcon$1.FontIcons.XCirlce,
        onClick: ()=>{
            handleClose();
        },
        onKeyUp: (e)=>{
            if (e.key === 'Enter') {
                handleClose();
            }
            if (closeButtonProps?.onKeyUp) {
                closeButtonProps?.onKeyUp(e);
            }
        }
    })));
};
const Alert = styled__default.default(BaseStandardAlert)`
  ${alert.baseAlertStyle}
  ${({ look  })=>alert.getAlertTheme({
        look
    })}
  display: flex;

  .bf-alert__body {
    flex: 1 1 0%;
  }

  .bf-alert__heading {
    font-family: ${fonts.fontFamilyMedium};
    font-size: 16px;
    line-height: 1.4;
    margin-bottom: 5px;
  }

  .bf-alert__icon {
    flex-shrink: 0;
    margin-top: 1px;
    margin-inline-end: 10px;
    min-width: 0;
  }

  .bf-alert__message {
    white-space: normal;
  }

  .bf-button__close {
    align-self: flex-start;
    flex-shrink: 0;
    margin: -4px -4px -4px 0;
    padding: 4px;

    .bf-button__close-icon {
      font-size: 22px;
    }
  }
`;
const StandardAlert = (props)=>{
    const { look =alert$1.AlertLooks.Warning , ...otherProps } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(Alert, _extends({}, otherProps, {
        look: look
    })));
};

exports.StandardAlert = StandardAlert;
//# sourceMappingURL=standard-alert.js.map
